import { createFileRoute } from '@tanstack/react-router';

import { SchedulePage } from '@/features/student/SchedulePage';
import { requireRole } from '@/lib/routeGuards';

export const Route = createFileRoute('/_authed/schedule')({
  beforeLoad: () => requireRole('student'),
  component: SchedulePage,
});
